var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24176 10.7206H2.38925C2.38925 10.7206 2.92627 8.58908 3.73182 8.58908C4.53737 8.58908 4.84817 13.5425 6.09289 13.5425C7.3376 13.5425 8.93762 2.43402 10.1227 2.43402C11.3078 2.43402 12.1531 6.87421 12.1531 6.87421",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4523 10.563C11.855 8.60319 10.1686 9.99574 10.1464 11.4969C10.1464 13.7317 12.8203 15.5659 13.4523 15.5659C14.0844 15.5659 16.7582 13.7317 16.7582 11.4969C16.736 9.99574 15.0496 8.60319 13.4523 10.563Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTesting);
export default __webpack_public_path__ + "static/media/home_testing.05e68192f005d4f926cc5406c8e04dfb.svg";
export { ForwardRef as ReactComponent };